// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PKo6","left":"styles_left__xzDwT"};